<template>
    <div>
        <Header title="比赛信息" memo="查看比赛信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div></div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-select show-search v-model="query.unit" :filter-option="false" :not-found-content="null" @search="doLoadUnit" @change="execQuery" :style="{ width: '200px' }">
                            <a-select-option value="">
                                所有机构
                            </a-select-option>
                            <a-select-option v-for="item in units" :key="item.id" :value="item.id" :label="item.name">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <!-- <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item> -->
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" expandRowByClick bordered :pagination="false">
            <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
                参赛设备：
                <a-button v-for="ud in record.uds" :key="ud.did" :style="{ marginRight: '5px', marginBottom: '5px' }">[{{ ud.sno }}] {{ ud.dname }} / {{ ud.name }}</a-button>
            </div>
            <a-table-column key="name" ellipsis>
                <span slot="title">比赛名称</span>
                <template slot-scope="text, record">
                    <a-tag color="#f50" v-if="record.state == 'Wait'">
                        未开始
                    </a-tag>
                    <a-tag color="#87d068" v-if="record.state == 'Start'">
                        已开始
                    </a-tag>
                    <a-tag color="#108ee9" v-if="record.state == 'Finish'">
                        已结束
                    </a-tag>
                    <span>{{ record.type | raceType }} / {{ (record.type + '_' + record.level) | raceLevel }} / {{ record.name }}</span>
                </template>
            </a-table-column>
            <a-table-column key="start" ellipsis width="360px">
                <span slot="title">比赛时间</span>
                <template slot-scope="text, record">
                    <span v-if="record.state != 'Wait'">{{ record.start }} 至 {{ record.end || '尚未结束' }}</span>
                    <span v-else>尚未开始</span>
                </template>
            </a-table-column>
            <a-table-column key="time" ellipsis width="180px">
                <span slot="title">开始时间</span>
                <template slot-scope="text, record">
                    <template v-if="record.time">
                        <span>{{ record.time }}</span>
                    </template>
                    <span v-else>尚未开始</span>
                </template>
            </a-table-column>
            <a-table-column key="uds" ellipsis width="100px">
                <span slot="title">参与人数</span>
                <template slot-scope="text, record">
                    <span>{{ record.uds.length }}</span>
                </template>
            </a-table-column>
            <a-table-column key="uds" ellipsis width="150px">
                <span slot="title">比赛成绩</span>
                <template slot-scope="text, record">
                    <a-button icon="ordered-list" @click="showRstDlg(record)" v-if="record.state === 'Finish'">
                        查看成绩
                    </a-button>
                    <span v-else>
                        尚未结束
                    </span>
                </template>
            </a-table-column>
        </a-table>

        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />

        <RstComp title="比赛成绩" :item="now" :show.sync="rstDlg" v-if="rstDlg"></RstComp>
    </div>
</template>

<script>
import RstComp from './RstComp'

export default {
    name: 'AtePlatRace',
    components: {
        RstComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        }
    },
    data() {
        return {
            rstDlg: false,
            units: [],
            query: {
                page: 1,
                size: 10,
                time: 0,
                unit: ''
            },
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            }
        }
    },
    filters: {
        raceType: value => {
            switch (value) {
                case 'R01':
                    return '注意力猜拳'
                case 'R02':
                    return '舒尔特方格'
                case 'R03':
                    return '虚实线'
                case 'R04':
                    return '中心悬点'
            }
        },
        raceLevel: value => {
            switch (value) {
                case 'R01_Easy':
                    return '简单（限时 2 秒）'
                case 'R01_Normal':
                    return '普通（限时 1.5 秒）'
                case 'R01_Hard':
                    return '困难（限时 1 秒）'
                case 'R02_Easy':
                    return '简单（3*3 方格）'
                case 'R02_Normal':
                    return '普通（4*4 方格）'
                case 'R02_Hard':
                    return '困难（5*5 方格）'
                case 'R03_Easy':
                    return '简单（1 行 2 图）'
                case 'R03_Normal':
                    return '标准（2 行 4 图）'
                case 'R03_Hard':
                    return '困难（2 行 6 图）'
                case 'R04_Easy':
                    return '简单（4 行 6 列）'
                case 'R04_Normal':
                    return '标准（5 行 8 列）'
                case 'R04_Hard':
                    return '困难（6 行 10 列）'
            }
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云测评', '比赛信息'])
        this.doLoad()
        this.doLoadUnit()
    },
    methods: {
        doLoadUnit(name) {
            this.$http
                .get('/sys/data/user/unit', {
                    params: {
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.units = result.datas
                })
        },
        doLoad() {
            this.$http
                .get('/cts/ate/race/mgr/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },

        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                unit: ''
            }
            this.doLoad()
        },
        showRstDlg(item) {
            this.now = item
            this.rstDlg = true
        }
    }
}
</script>
